module.exports = __webpack_public_path__ + "img/12-1.1d91628f.jpg";